import { useFormik } from "formik"
import * as Yup from "yup"
import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  CardSubtitle,
  Spinner,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"

const IPForm = ({ onSubmit, loading, error, formMode, ip }) => {
  // Initialize Formik Hook for Validation
  // This hook manages form state and validation using Formik.
  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: ip ? ip?.name : "",
      code: ip ? ip?.code : "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("This name is required").min(3),
      code: Yup.string().required("This code is required").min(3),
    }),
    onSubmit: values => {
      onSubmit(values)
    },
  })

  return (
    <Card>
      <CardBody>
        <CustomHeaderTitle
          loading={loading} //Boolean flag to display loading state
          title={formMode === "Edit" ? "Edit IP" : "Add IP"} // String to display as the header title
          lgColumn={3} // Number to control the width of columns based on layout needs
          rowCount={false} // Boolean to show/hide the row number selector
          orderingList={false} // Boolean to show/hide ordering dropdown
          searchBox={false} // Boolean to show/hide search input box
          rightBtn={true} // Boolean to show/hide right-side button (for example, a back button)
          rightBtnTitle={"Back"} // String for setting the right button's label
          rightBtnRoute={"/ips"} // Route for the right button's navigation
        />

        <Form
          onSubmit={e => {
            e.preventDefault()
            validationType.handleSubmit()
            return false
          }}
        >
          <div className="mb-3">
            <Label className="form-label">Name</Label>
            <Input
              name="name"
              placeholder="Name"
              type="text"
              defaultValue={ip?.name}
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              invalid={
                (validationType.touched.name && validationType.errors.name) ||
                error?.name?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.name && validationType.errors.name) ||
            error?.name?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.name || error?.name?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label">Code</Label>
            <Input
              name="code"
              placeholder="Code"
              type="text"
              defaultValue={ip?.code}
              onChange={validationType.handleChange}
              onBlur={validationType.handleBlur}
              invalid={
                (validationType.touched.code && validationType.errors.code) ||
                error?.code?.[0]
                  ? true
                  : false
              }
            />
            {(validationType.touched.code && validationType.errors.code) ||
            error?.code?.[0] ? (
              <FormFeedback type="invalid">
                {validationType.errors.code || error?.code?.[0]}
              </FormFeedback>
            ) : null}
          </div>

          <div className="d-flex flex-wrap gap-2">
            <Button type="submit" color="primary" disabled={loading}>
              {loading
                ? "Please Wait..."
                : formMode === "Add"
                ? "Submit"
                : "Update"}
            </Button>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default IPForm
